import type { FilterChipProps } from '../types';
import CreatedDateFilterChip from './created-date-filter-chip';
import DeliveryDateFilterChip from './delivery-date-filter-chip';
import DeliveryPreferenceFilterChip from './delivery-preference-filter-chip';
import DeliveryQueuedFilterChip from './delivery-queued-chip';
import DeliveryStageFilterChip from './delivery-stage-filter-chip';
import FinanceManagerFilterChip from './finance-manager-filter-chip';
import FundingMethodFilterChip from './funding-method-chip';
import LastUpdatedDateFilterChip from './last-updated-date-filter-chip';
import LenderChip from './lender-chip';
import PickupDateFilterChip from './pickup-date-filter-chip';
import PriceLockedFilterChip from './price-locked-chip';
import PriorityFilterChip from './priority-filter-chip';
import RapidReconStepFilterChip from './rapid-recon-step-filter-chip';
import SalesRepFilterChip from './sales-rep-filter-chip';
import StatusFilterChip from './status-filter-chip';
import TradedInFilterChip from './traded-in-filter-chip';

const AllFilterChip = (props: FilterChipProps) => {
  const {
    type,
    deleteFilter,
    filtersState,
    setFiltersState,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  switch (type) {
    case 'status': {
      return (
        <StatusFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }
    case 'delivery_stage': {
      return (
        <DeliveryStageFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }
    case 'delivery_preference': {
      return (
        <DeliveryPreferenceFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }
    case 'priority': {
      return (
        <PriorityFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }
    case 'finance_manager': {
      return (
        <FinanceManagerFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }
    case 'sales_rep': {
      return (
        <SalesRepFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'funding_method': {
      return (
        <FundingMethodFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'lender': {
      return (
        <LenderChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'delivery_queued': {
      return (
        <DeliveryQueuedFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'price_locked': {
      return (
        <PriceLockedFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'traded_in': {
      return (
        <TradedInFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'rapid_recon_step': {
      return (
        <RapidReconStepFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'delivery_date': {
      return (
        <DeliveryDateFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'pickup_date': {
      return (
        <PickupDateFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'last_updated_date': {
      return (
        <LastUpdatedDateFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    case 'created_date': {
      return (
        <CreatedDateFilterChip
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          deleteFilter={deleteFilter}
          shouldDeleteWhenNoFiltersAreSelected={
            shouldDeleteWhenNoFiltersAreSelected
          }
        />
      );
    }

    default:
      return <div>Chip placeholder for: {type}</div>;
  }
};

export default AllFilterChip;
